// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__elge-","select":"styles_select__2tc9n"};